import { actionPhrase } from '../cards';
/**
 * The recommendation and its provenance:
 *   1. the recommended action (+ sizing intent),
 *   2. the deviation from the baseline line, when the exploit layer overrode it (finalAction differs),
 *   3. one line per fired rule carrying its `principle` (+ villainNote), tagged with the rule id.
 * When no rules fired, a single line states the play is the standard baseline.
 */
export function ruleFired(facts) {
    const rec = facts.recommendation;
    const lines = [];
    lines.push({
        kind: 'recommendation',
        text: `Recommended: ${actionPhrase(rec.action, rec.sizingIntent)}.`,
        tone: 'neutral',
    });
    // The exploit deviation, when the final action differs from the honest baseline.
    if (rec.finalAction !== rec.baselineAction) {
        const because = rec.targetStatement ? `: ${rec.targetStatement}` : '';
        lines.push({
            kind: 'recommendation',
            text: `This deviates from the baseline ${actionPhrase(rec.baselineAction)}${because}.`,
            tone: 'neutral',
        });
    }
    if (rec.firedRules.length === 0) {
        lines.push({
            kind: 'rule',
            text: 'No exploit read applies. This is the standard low-stakes line.',
            tone: 'neutral',
        });
        return lines;
    }
    for (const r of rec.firedRules) {
        const note = r.villainNote ? ` ${r.villainNote}` : '';
        lines.push({ kind: 'rule', text: `${r.principle}${note}`, tone: 'neutral', ruleId: r.id });
    }
    return lines;
}
//# sourceMappingURL=ruleFired.js.map